import OliverText from "@builder/components/general/OliverText";
import { useTranslation } from "react-i18next";
import TooltipElement from "../Tooltip";
import "./style.scss";

export type CheckboxOption = {
    value: string;
    img: string;
    checked: boolean;
    tooltip?: string;
};

interface CheckboxInputProps {
    title: string;
    options: CheckboxOption[];
    callback: (value: string, checked: boolean) => void;
    disabled?: boolean;
    tooltips?: boolean;
}

const CheckboxInput: React.FC<CheckboxInputProps> = ({ title, options, callback, disabled }: CheckboxInputProps) => {
    const { t } = useTranslation();

    const handleCheckboxChange = (e: React.FormEvent<HTMLInputElement>): void => {
        callback(e.currentTarget.value, e.currentTarget.checked);
    };

    return (
        <div className="checkbox-input-wrapper">
            {title && <OliverText text={t("generalComponents.checkboxInput." + title)} size="xs" />}
            <div className="checkbox-row">
                {options.map((option, index) =>
                    option.tooltip && !disabled ? (
                        <TooltipElement key={index} text={t("generalComponents.checkboxInput." + option.tooltip)}>
                            <label>
                                <input
                                    type="checkbox"
                                    value={option.value}
                                    onChange={handleCheckboxChange}
                                    checked={option.checked}
                                    disabled={disabled}
                                />
                                <img src={option.img} />
                            </label>
                        </TooltipElement>
                    ) : (
                        <label key={index}>
                            <input
                                type="checkbox"
                                value={option.value}
                                onChange={handleCheckboxChange}
                                checked={option.checked}
                                disabled={disabled}
                            />
                            <img src={option.img} />
                        </label>
                    )
                )}
            </div>
        </div>
    );
};

export default CheckboxInput;
